import { render, staticRenderFns } from "./NotificationsLogs.vue?vue&type=template&id=0928af2f&scoped=true"
import script from "./NotificationsLogs.vue?vue&type=script&lang=js"
export * from "./NotificationsLogs.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./NotificationsLogs.vue?vue&type=style&index=1&id=0928af2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0928af2f",
  null
  
)

export default component.exports